/**
 * The frame's two calls into the light. The choreography is garnish: if its chunk cannot load, the
 * dock still opens and closes, only without the light. It loads on first use, so the top bar's first
 * paint does not carry it.
 */

/** The lamp glows and its spout flares (130 ms); the frame mounts the dock when this resolves. */
export async function openDjinnWithLight(origin?: Element | null): Promise<void> {
  try {
    const d = await import("./light/director");
    await d.leadIn(origin);
    d.expectArrival(origin);
  } catch {
    // Opened without the light.
  }
}

/** The figure flows back into the lamp while the dock slides out; `onSlide` says when the dock should start. */
export async function closeDjinnWithLight(onSlide: () => void): Promise<void> {
  let slid = false;
  const slide = () => {
    slid = true;
    onSlide();
  };
  try {
    const d = await import("./light/director");
    // A tab whose frames are throttled never finishes the flight; the dock still goes.
    await Promise.race([
      d.depart(d.figureStanding(), d.lampOf(null), slide),
      new Promise<void>((done) => setTimeout(done, 1500)),
    ]);
  } catch {
    // Closed without the light.
  }
  if (!slid) onSlide();
}
